import { OfferDefinitionsSearchFormModel } from '@/views/offerDefinitions/list/model/OfferDefinitionsSearchForm.model.ts';

export type OfferDefinitionsListTranslation = {
  actions: Record<'create', string>;
  table: {
    body: Record<'active' | 'name' | 'workflowCode', string>;
    head: Record<keyof OfferDefinitionsSearchFormModel, string>;
  };
};

export const offerDefinitionsListTranslation: OfferDefinitionsListTranslation = {
  actions: {
    create: 'Dodaj definicję',
  },
  table: {
    body: {
      active: 'Aktywny',
      name: 'Nazwa',
      workflowCode: 'Kod workflow',
    },
    head: {
      active: 'Aktywny',
      fullTextSearchInput: 'Wyszukaj',
    },
  },
};
